import React from 'react';
import './ApiKeyCard.css';

const ApiKeyCard = ({ keyData, onCopy, onRevoke, loading }) => {
  const id = keyData?.id;
  const displayKey = keyData?.maskedKey || keyData?.apiKeyPreview || keyData?.apiKey || '••••••••';
  const isRevoked = keyData?.revoked ?? (keyData?.enabled !== undefined ? !keyData.enabled : false);

  return (
    <div className="apikey-card" role="region" aria-label={`API Key ${displayKey}`}>
      <div className="apikey-details">
        <span className="apikey-value">{displayKey}</span>
        <span className={`status-badge ${isRevoked ? 'revoked' : 'active'}`} aria-live="polite">
          {isRevoked ? 'Revoked' : 'Active'}
        </span>
      </div>

      <div className="key-actions">
        <button
          type="button"
          onClick={() => onCopy(displayKey)}
          disabled={isRevoked}
          aria-disabled={isRevoked}
          aria-label={`Copy API key ${displayKey}`}
        >
          Copy
        </button>
        <button
          type="button"
          onClick={() => onRevoke(id)}
          disabled={isRevoked || loading}
          aria-disabled={isRevoked || loading}
          aria-label={`Revoke API key ${displayKey}`}
        >
          Revoke
        </button>
      </div>
    </div>
  );
};

export default ApiKeyCard;
